import React, { ReactNode, useCallback } from "react";
import { createTheme, makeStyles, MenuItem, Select, ThemeProvider } from "@material-ui/core";
import { SelectColor, SelectVariant } from "../../models/element";
import { uniq } from "../../utils/ObjectUtils";

interface SelectStyleProps {
    // 配色
    color?: SelectColor;
    // 表示形式
    variant?: SelectVariant;
    // 活性化
    isActive?: boolean;
}

interface SelectProps extends SelectStyleProps {
    // 要素ID
    id?: string;
    // リスト配列
    childrens: ReactNode[];
    // 初期値
    defaultValue?: ReactNode;
    // クリックイベント
    onChange?: (target: string) => void;
}

const useStyles = makeStyles({
    fullWidth: {
        width: "100%",
        // color: "var(--loading-bg)",
        "& .MuiSelect-iconOutlined": {
            // color: "var(--loading-bg)",
        },
        "& .MuiOutlinedInput-notchedOutline": {
            // borderColor: "var(--loading-bg)",
        },
    },
});

const theme = createTheme({
    palette: {
        secondary: {
            main: "#12e07e",
        },
    },
});

const PuiSelect = React.forwardRef<HTMLDivElement, SelectProps>(function PuiSelect(props, ref) {
    // パラメータ初期化
    const {
        id,
        childrens,
        defaultValue = "",
        onChange,
        color = "secondary",
        variant = "outlined",
        isActive = true,
    } = props;
    const classes = useStyles();
    const [val, setVal] = React.useState(defaultValue);

    // 内容編集イベント
    const handleChange = useCallback(
        (event: React.ChangeEvent<{ value: unknown }>) => {
            setVal(String(event.target.value));
            if (onChange) {
                onChange(String(event.target.value));
            }
        },
        [onChange]
    );

    return (
        <ThemeProvider theme={theme}>
            <Select
                id={id}
                ref={ref}
                displayEmpty={true}
                color={color}
                variant={variant}
                value={val}
                disabled={!isActive}
                onChange={handleChange}
                className={classes.fullWidth}
                SelectDisplayProps={{ style: { padding: 10 } }}
            >
                {uniq(childrens).map((children, index) => (
                    <MenuItem key={index} value={children}>
                        {children}
                    </MenuItem>
                ))}
            </Select>
        </ThemeProvider>
    );
});

export default PuiSelect;
